import { useEffect, useRef } from 'react';
import { CommunityUserForHireListItem as ListItem } from 'types/community';
import { VoidCallback } from 'types/callbacks';
import UserListItem, { PlaceholderUserListItem } from './UserListItem';
import styles from './UserList.module.css';

type Props = {
  listItems?: ListItem[] | null;
  hasMoreItems?: boolean;
  onScrollNearEnd?: VoidCallback;
};

export default function UserList({
  listItems,
  hasMoreItems,
  onScrollNearEnd,
}: Props) {
  const observerContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const callback: IntersectionObserverCallback = ([entry]) => {
      if (hasMoreItems && entry.isIntersecting) {
        onScrollNearEnd && onScrollNearEnd();
      }
    };

    const options = {
      rootMargin: '250px',
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(observerContainer.current!);

    return () => observer.disconnect();
  }, [hasMoreItems]);

  function getItems(listItems?: ListItem[] | null) {
    if (listItems === undefined || listItems === null) {
      return [...Array(5).keys()].map((i) => (
        <PlaceholderUserListItem key={i} />
      ));
    }

    return listItems.map((listItem) => (
      <UserListItem key={listItem.ownerId} item={listItem} />
    ));
  }

  const items = getItems(listItems);

  return (
    <div className={styles.List}>
      <ul>{items}</ul>
      <div ref={observerContainer} className={styles.ObserverContainer} />
    </div>
  );
}
